import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {CardPerso,DetailDossierFactureListe,FolderList} from '@gull'
import axios from 'axios';
import swal from "sweetalert2";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'

const useLoad = (clientId,reloadFolder) => {
    const t = useTranslate()
    const [loading,setLoading]=useState(true)
    const [allCustomerFolders,setAllCustomerFolders]=useState([])
    const [folderIds,setFolderIds]=useState([])

    const organizeData = (sortedArr) => {
        let folderIds = sortedArr.map(value=>value.id)

        setFolderIds(folderIds)
        setAllCustomerFolders(sortedArr)
    };
    
    useEffect(function () {
        (async function() {
            if(allCustomerFolders && reloadFolder){
                setLoading(true)
                let url=(clientId) ? process.env.REACT_APP_API_URL+"api/facture/dossier_b2b/get_all_of_client/"+clientId : process.env.REACT_APP_API_URL+"api/facture/dossier_b2b/get_all/0";
                const response  = await axios.get(url).then((response) => {
                    if(!response.data.valid){
                        let interms='';
                        var keys = Object.keys(response.data.errors);
                        for(var i = 0; i < keys.length; i++){
                            interms+=response.data.errors[keys[i]].join(',')+','
                        }
                        interms=interms.split(',')
                        let messageError='';
                        interms.forEach(interm=>messageError+=t(interm)+'. ')
                        messageError=messageError.replace('undefined','');
                        swal.fire(messageError, "", "error");
                    }else{
                        let datas = (clientId) ? response.data.data.dossier_b2b : response.data.data
                        let sortedArr = datas.sort((a, b) => Number(b.nbr) - Number(a.nbr));
                        organizeData(sortedArr)
                    }
                }).catch((error) => {
                    console.log(error)
                    if(error=='end_session') return;
                    let messageError
                    if(error.response==undefined){
                        messageError='unknowError'
                    }
                    else if(error.response.status==403){
                        messageError='forbiddenGeneral'
                    }
                    else {
                        messageError='unknowError'
                    }
                    swal.fire(t(messageError), "", "error");
                })
                setLoading(false)
            }
        })()
    }, [reloadFolder])

    return [loading,allCustomerFolders,folderIds,organizeData]
}

const Folders = (props) => {
    const t = useTranslate();
    const [loading,allCustomerFolders,folderIds,organizeData] = useLoad(props.clientId,props.reloadFolder)
    const [selectedFolder,setSelectedFolder] = useState(false)
    const [organizeType,setOrganizeType] = useState('nbrDecroissant')

    const openFolder = (folderId) => {
        setSelectedFolder(folderId)
    };

    const closeFolder = () => {
        setSelectedFolder(false)
        props.setReloadFolder(Date.now())
    };

    const handleClick = (action) => {
        let indexOfFolder = folderIds.indexOf(selectedFolder)

        if(action=='prev'){
            setSelectedFolder(folderIds[+indexOfFolder - 1])
        }else{
            setSelectedFolder(folderIds[+indexOfFolder + 1])
        }
    };

    return(
        <div>
            <div className='row'>
                <div className="col-12">
                    {selectedFolder && 
                        <div className='mb-2 d-flex justify-content-between'>
                            <FontAwesomeIcon icon={faArrowLeft} className='pointer' onClick={()=>closeFolder()}/>
                            <span>
                                <button className='btn btn-sm btn-light' onClick={()=>handleClick('prev')}><FontAwesomeIcon icon={faChevronLeft}/>&nbsp;&nbsp;{t('previousFolder')}</button>&nbsp;&nbsp;
                                <button className='btn btn-sm btn-light' onClick={()=>handleClick('next')}>{t('nextFolder')}&nbsp;&nbsp;<FontAwesomeIcon icon={faChevronRight}/></button>
                            </span>
                        </div>
                    }
                    {!selectedFolder ?
                        <CardPerso header={t('folders')}>
                            <FolderList folders={allCustomerFolders} openFolder={openFolder} organizeData={organizeData} organizeType={organizeType} setOrganizeType={setOrganizeType} filterStateActive={props.showFilter} loading={loading}/>
                        </CardPerso>
                    :
                        <DetailDossierFactureListe folderId={selectedFolder} bigLoader={false} linkOnCLient={true} from='modal'/>
                    }
                </div>
            </div>
        </div>
    )
}

export default Folders;